export default __webpack_public_path__ + "static/media/live-monitoring.b734967b.png";